module.exports = __webpack_public_path__ + "img/nodata.f85f31d8.svg";